import { useEffect } from 'react';

export const useWindowEvents = (eventName: string, callback: any) => {
  useEffect(() => {
    window.addEventListener(eventName, callback);

    return () => {
      window.removeEventListener(eventName, callback);
    };
  }, [eventName, callback]);
};
